import { gql } from '@apollo/client';

export const FETCH_ACCOUNT_HOLDER_NAME = gql`
  query fetchAccountHolderName($id: SafeString!) {
    fetchAccount(input: { accountId: $id }) {
      account {
        user {
          firstName
        }
      }
    }
  }
`;
